import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { setItemInLocalStorage, getItemFromLocalStorage } from 'helpers/localstorage';
import toast from 'react-hot-toast';
import api from 'api';

const localOrg = getItemFromLocalStorage('org');
const fcmSlot = getItemFromLocalStorage('fcm-token');

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MESUREMENT_ID,
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const requestForToken = () => {
  const pushNotificationKey = process.env.REACT_APP_WEB_PUSH_NOTIFICATION_KEY;
  if (pushNotificationKey) {
    return getToken(messaging, {
      vapidKey: process.env.REACT_APP_WEB_PUSH_NOTIFICATION_KEY,
    })
      .then(currentToken => {
        // todo optimization
        if ((currentToken && localOrg?.token) || fcmSlot) {
          api.post(`/admin/fcm/token`, {
            token: currentToken,
          });
          setItemInLocalStorage('fcm-token', currentToken);
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch(err => {
        console.log('An error occurred while retrieving token. ', err);
      });
  }
};

export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      toast.success(`${payload?.notification?.title}: ${payload?.notification?.body}`);
    });
  });

export { messaging, getToken, onMessage };
